const types = {
  SET_NETWORK_DETAILS: 'SET_NETWORK_DETAILS',
  UPDATE_NETWORK_DETAILS: 'UPDATE_NETWORK_DETAILS',
  SET_NETWORK_DETAILS_UNSAVED_CHANGES: 'SET_NETWORK_DETAILS_UNSAVED_CHANGES',
  PATCH_NETWORK_DETAILS_ROW: 'PATCH_NETWORK_DETAILS_ROW',
};

export default types;
